import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TreadsListComponent } from './components/thread-list/treads-list.component';

const routes: Routes = [
  {
    path: '',
    component: TreadsListComponent,
  },
  {
    path: ':threadId',
    loadChildren: () =>
      import('../tread/tread.module').then((m) => m.TreadModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class TreadsListRoutingModule {}
